import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { Controller } from 'lib_ts/enums/routing/controllers';
import { AdminUsersRoutes } from 'lib_ts/enums/routing/routes/admin-users';
import { IServerResponse } from 'lib_ts/interfaces/common/i-server-response';
import { IUser } from 'lib_ts/interfaces/i-user';
import { BaseRESTService } from 'services/_base-rest.service';

export class AdminUsersService extends BaseRESTService {
  private static instance: AdminUsersService;
  static getInstance(): AdminUsersService {
    if (!AdminUsersService.instance) {
      AdminUsersService.instance = new AdminUsersService();
    }

    return AdminUsersService.instance;
  }

  private constructor() {
    super({
      controller: Controller.AdminUsers,
    });
  }

  /** get all users, limited to user's team if not a super admin */
  async getUsers(global: boolean): Promise<IUser[]> {
    return await this.get({
      uri: AdminUsersRoutes.GetUsers,
      params: { global: global } as any,
    });
  }

  /** password (plaintext) must be provided */
  async createUser(data: Partial<IUser>): Promise<IServerResponse> {
    if (!data._parent_id || !data._parent_def || !data._parent_field) {
      throw new Error('Cannot post without parent (e.g. team) details');
    }

    if (!data.machineID) {
      throw new Error('Cannot post without machine details');
    }

    /** default value of domains to an empty array */
    if (!ArrayHelper.isArray(data.domains)) {
      data.domains = [];
    }

    return await this.post(
      {
        uri: AdminUsersRoutes.CreateUser,
      },
      data
    );
  }

  /** if password (plaintext) is provided, server will generate a new password hash */
  async updateUser(data: Partial<IUser>): Promise<IServerResponse> {
    if (!data._id) {
      throw new Error('Cannot put without id');
    }

    return await this.put(
      {
        uri: `${AdminUsersRoutes.UpdateUser}/${data._id}`,
      },
      data
    );
  }

  async deleteUsers(userIDs: string[]): Promise<IServerResponse> {
    return await this.post(
      {
        uri: AdminUsersRoutes.DeleteUsers,
      },
      userIDs
    );
  }

  async resetPasswordUrl(userID: string): Promise<IServerResponse> {
    return await this.get({
      uri: `${AdminUsersRoutes.GetResetPasswordUrl}/${userID}`,
    });
  }
}
